<app-vertical *ngIf="(dataLayout$ | async) === 'vertical'"></app-vertical>
<app-horizontal *ngIf=" (dataLayout$ | async)==='horizontal'"></app-horizontal>